import { create } from 'zustand';

/**
 * In-app re-engagement nudge (Channel 2 of shared-docs/re-engagement-nudges.md).
 *
 * The nudge is delivered on the launch-time GET /sessions response (the sync
 * pull). No new API routes — pull.js calls `setNudge` with whatever the server
 * returned. The banner is rendered once, respecting a per-id dismissal flag in
 * localStorage['nudgeDismissed:<id>'].
 */
const useNudgeStore = create((set) => ({
  nudge: null, // { id, title, body, createdAt } | null

  setNudge: (nudge) => {
    if (!nudge || !nudge.id) {
      set({ nudge: null });
      return;
    }
    // Already dismissed on this device → don't resurface.
    try {
      if (localStorage.getItem(`nudgeDismissed:${nudge.id}`)) {
        set({ nudge: null });
        return;
      }
    } catch {
      // localStorage unavailable — show it anyway.
    }
    set({ nudge });
  },

  dismiss: () => {
    set((s) => {
      if (s.nudge?.id) {
        try {
          localStorage.setItem(`nudgeDismissed:${s.nudge.id}`, '1');
        } catch {
          // ignore
        }
      }
      return { nudge: null };
    });
  },
}));

export default useNudgeStore;
